<!-- 优诊通的优势 -->
<template>
  <div id="advantage">
    <vice-title>
      <h3>{{ this.$t("lang.BetterMedicalCare.advantages") }}</h3>
    </vice-title>
    <div class="advantage">
      <div class="advantage-inner">
        <el-row :gutter="35">
          <el-col v-for="item of advantageLists" :key="item.id" :span="8"
            ><div class="advantage-item">
              <h3 :class="languageTitle">{{ item.title }}</h3>
              <p :class="languageContent">{{ item.content }}</p>
            </div></el-col
          >
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import ViceTitle from "../ViceTitle";
export default {
  name: "MedicalAdvantage",
  components: {
    ViceTitle
  },
  data() {
    return {
      languageTitle: "",
      languageContent: "",
      advantageList: [
        {
          id: 1,
          title: this.$t("lang.BetterMedicalCare.hospitalsNumber"),
          content: this.$t("lang.BetterMedicalCare.hospitalsNumberDetail")
        },
        {
          id: 2,
          title: this.$t("lang.BetterMedicalCare.serviceRange"),
          content: this.$t("lang.BetterMedicalCare.serviceRangeDetail")
        },
        {
          id: 3,
          title: this.$t("lang.BetterMedicalCare.serviceHours"),
          content: this.$t("lang.BetterMedicalCare.serviceHoursDetail")
        },
        {
          id: 4,
          title: this.$t("lang.BetterMedicalCare.respondEfficiency"),
          content: this.$t("lang.BetterMedicalCare.respondEfficiencyDetail")
        },
        {
          id: 5,
          title: this.$t("lang.BetterMedicalCare.OurCooperation"),
          content: this.$t("lang.BetterMedicalCare.OurCooperationDetail")
        },
        {
          id: 6,
          title: this.$t("lang.BetterMedicalCare.oneStop"),
          content: this.$t("lang.BetterMedicalCare.oneStopDetail")
        }
      ]
    };
  },
  beforeUpdate() {
    this.setStyle();
  },
  mounted() {
    this.setStyle();
  },
  methods: {
    setStyle() {
      if (this.$i18n.locale === "en-US") {
        this.languageTitle = "advantage-item-title-us";
        this.languageContent = "advantage-item-content-us";
      } else if (this.$i18n.locale === "zh-CN") {
        this.languageTitle = "advantage-item-title";
        this.languageContent = "advantage-item-content";
      }
    }
  },
  computed: {
    advantageLists() {
      return [
        {
          id: 1,
          title: this.$t("lang.BetterMedicalCare.hospitalsNumber"),
          content: this.$t("lang.BetterMedicalCare.hospitalsNumberDetail")
        },
        {
          id: 2,
          title: this.$t("lang.BetterMedicalCare.serviceRange"),
          content: this.$t("lang.BetterMedicalCare.serviceRangeDetail")
        },
        {
          id: 3,
          title: this.$t("lang.BetterMedicalCare.serviceHours"),
          content: this.$t("lang.BetterMedicalCare.serviceHoursDetail")
        },
        {
          id: 4,
          title: this.$t("lang.BetterMedicalCare.respondEfficiency"),
          content: this.$t("lang.BetterMedicalCare.respondEfficiencyDetail")
        },
        {
          id: 5,
          title: this.$t("lang.BetterMedicalCare.OurCooperation"),
          content: this.$t("lang.BetterMedicalCare.OurCooperationDetail")
        },
        {
          id: 6,
          title: this.$t("lang.BetterMedicalCare.oneStop"),
          content: this.$t("lang.BetterMedicalCare.oneStopDetail")
        }
      ];
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/global";
#advantage {
  width: 75%;
  margin: 0 auto;
  background: $pureWhite;
  overflow: hidden;
  .advantage {
    width: 100%;
    height: 750px;
    background: url("../../assets/images/bestMedicalCare/advantage.jpg");
    background-size: 100% 100%;
    overflow: hidden;
    display: flex;
    align-items: center;
    .advantage-inner {
      width: 837px;
      margin: 0 auto;
      .advantage-item {
        height: 250px;
        background: $pureWhite;
        margin-bottom: 62px;
        box-shadow: 0 8px 53px 6px rgba(125, 190, 255, 0.11);
        border-radius: 10px;
        overflow: hidden;
        .advantage-item-title {
          margin-top: 26px;
          font-size: 20px;
          font-weight: $weight500;
          text-align: center;
          color: $publicBlue;
        }
        .advantage-item-title-us {
          height: 20px;
          margin-top: 26px;
          font-size: 16px;
          font-weight: $weight500;
          text-align: center;
          color: $publicBlue;
        }
        .advantage-item-content {
          margin: 20px;
          color: #c3c3c3;
          font-size: 16px;
          line-height: 27px;
          word-break: break-all;
        }
        .advantage-item-content-us {
          /*margin: 20px;*/
          margin: 30px 20px;
          color: #c3c3c3;
          font-size: 14px;
          line-height: 18px;
          word-break: break-all;
        }
      }
    }
  }
}
</style>
